import React from "react";
import { TERMS_VERSION } from "../../common/constants";
import logo from "../../assets/logo_round.png";

const TermsAndConditions = () => {
  return (
    <div
      style={{
        backgroundColor: "#f5f7fb",
        minHeight: "100vh",
        padding: "60px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          lineHeight: "1.8",
          color: "#333",
        }}
      >
        {/* Brand Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            marginBottom: "24px",
            paddingBottom: "20px",
            borderBottom: "1px solid #eee",
          }}
        >
          <img
           src={logo}
            alt="Speak Bold with KK Logo"
            style={{
              width: "56px",
              height: "56px",
              objectFit: "contain",
              borderRadius: "10px",
              backgroundColor: "#fff",
            }}
          />

          <div>
            <div
              style={{
                fontSize: "1.25rem",
                fontWeight: "700",
                color: "#111",
                lineHeight: "1.2",
              }}
            >
              Speak Bold with KK
            </div>

            <div
              style={{
                fontSize: "0.95rem",
                color: "#666",
                marginTop: "4px",
              }}
            >
              Learn confidently. Speak boldly.
            </div>
          </div>
        </div>

        {/* Header */}
        <h1
          style={{
            marginBottom: "10px",
            fontSize: "2.2rem",
            fontWeight: "700",
            color: "#111",
          }}
        >
          Terms & Conditions
        </h1>

        <p style={{ color: "#666", marginBottom: "30px" }}>
          Speak Bold with KK (operating the SpeakBold Club App) • Version {TERMS_VERSION}
        </p>

        <p>
          By accessing or using <strong> SpeakBold Club App </strong> and website <strong>Speak Bold with KK </strong>, or services, you agree to the following Terms and
          Conditions. Please read them carefully.
        </p>

        <h2 style={sectionTitleStyle}>Services Offered</h2>
        <p>
          Speak Bold with KK (SpeakBold Club App) provides online communication training, group
          discussions, interview preparation, and premium content for learners
          seeking to improve their English-speaking skills and confidence.
        </p>

        <h2 style={sectionTitleStyle}>User Responsibilities</h2>
        <ul style={listStyle}>
          <li>You must provide accurate and up-to-date information.</li>
          <li>You agree not to misuse, copy, or redistribute our content.</li>
          <li>
            You must follow session guidelines and maintain respectful behavior.
          </li>
        </ul>

        <h2 style={sectionTitleStyle}>Payments</h2>
        <p>
          All payments for sessions or premium content are processed securely
          through <strong>Razorpay</strong> and <strong>Google Play Billing</strong> . Speak Bold with KK or SpeakBold Club App does not store or
          handle your payment card details.
        </p>

        <h2 style={sectionTitleStyle}>Content Usage</h2>
        <p>
          All learning materials, videos, text, images, and digital content are
          the intellectual property of Speak Bold with KK. Unauthorized copying,
          distribution, or commercial use is strictly prohibited.
        </p>

        <h2 style={sectionTitleStyle}>Modifications</h2>
        <p>
          Speak Bold with KK may update or modify these Terms at any time.
          Continued use of our services signifies acceptance of the updated Terms.
        </p>

        <h2 style={sectionTitleStyle}>Contact Us</h2>
        <p>
          If you have any questions regarding these Terms, you can reach us at:
        </p>

        <div
          style={{
            backgroundColor: "#f9fafc",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "15px",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <strong>Email:</strong> support@speakboldwithkk.com
          </p>
        </div>

        <div
          style={{
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid #eee",
            fontSize: "0.9rem",
            color: "#888",
          }}
        >
          Last Updated: {new Date().getFullYear()} <br />
          © {new Date().getFullYear()} Speak Bold with KK. All rights reserved.
        </div>
      </div>
    </div>
  );
};

const sectionTitleStyle = {
  marginTop: "35px",
  fontSize: "1.4rem",
  fontWeight: "600",
  color: "#222",
};

const listStyle = {
  paddingLeft: "20px",
  marginTop: "10px",
};

export default TermsAndConditions;